/**
 * dealRottingBadge — Pure Function (BOARD-09).
 *
 * Markiert Karten in 'in_kontakt' die zu lange dort stehen:
 * - enteredStatusAt > now() - 30d → rot '⏰ 30d'
 * - enteredStatusAt > now() - 14d → orange '⏰ 14d'
 * - sonst → null (kein Badge)
 *
 * Nur fuer Spalte 'in_kontakt' aktiv. Follow-up-Spalten haben Auto-Move,
 * Abschluss-Spalten sind final — beide brauchen kein Rotting.
 *
 * Pure: now ist Argument (kein Date.now()), testbar mit fixen Zeitstempeln.
 */

import { differenceInDays } from 'date-fns';
import type { Lead } from '../types';

export interface DealRottingBadge {
  color: 'orange' | 'red';
  label: string;
}

export function dealRottingBadge(lead: Lead, now: Date = new Date()): DealRottingBadge | null {
  if (lead.status !== 'in_kontakt') return null;

  const days = differenceInDays(now, new Date(lead.enteredStatusAt));

  if (days >= 30) return { color: 'red', label: '⏰ 30d' };
  if (days >= 14) return { color: 'orange', label: '⏰ 14d' };
  return null;
}
